export const data = [
  {
    order: '01',
    title: 'Full Cycle<br />Product Development',
    link: '/full-cycle-product-development/',
    id: 'home-services-full-cycle-product-developments',
    description:
      'Boldare’s seasoned teams can help at each stage of innovation:',
    bullets: [
      'Prototype development',
      'MVP development',
      'Product-Market Fit',
      'Scaling products',
      'Business strategy',
      'Product strategy',
    ],
  },
  {
    order: '02',
    title: 'Product Design and&nbsp;Development',
    link: '/product-design-and-development/',
    id: 'home-services-product-design-and-development',
    description:
      'Clarify your vision, digitise your business or disrupt your industry with Boldare. Our tool kit includes:',
    bullets: [
      'Web Design and Development',
      'Mobile App Development',
      'Software Development',
      'Tech Stack Consulting',
      'Infrastructure Architecture',
      'Usability Testing',
    ],
  },
  {
    order: '03',
    title: 'Development<br />Teams',
    link: '/development-teams/',
    id: 'home-services-development-teams',
    description:
      'Boldare’s scrum teams can extend your in-house team or become your remote product development department. We offer:',
    bullets: [
      'Over 100 Software Developers, Designers and Scrum Masters',
      'Prototyping Teams',
      'MVP Teams',
      'Product-Market Fit Teams',
      'Scaling & Maturity Teams',
    ],
  },
  {
    order: '04',
    title: 'Machine learning',
    link: '/machine-learning/',
    id: 'home-services-machine-learning',
    description:
      'Boldare implements advanced machine learning models which, among many other things, can:',
    bullets: [
      'Automate tasks',
      'Improve decision-making',
      'Optimize costs and processes',
      'Help to understand customers',
      'Boost profitability',
    ],
  },
  {
    order: '05',
    title: 'Digital transformation',
    link: '/digital-transformation/',
    id: 'home-services-digital-transformation',
    description: 'Self-organizing scrum teams at Boldare deliver:',
    bullets: [
      'Design Sprints',
      'Innovation Workshops',
      'User & Market Research',
      'Customer Journey Mapping',
      'Information Architecture & User Flow',
      'Wireframing & Process Flows',
    ],
  },
];
